import React from "react";
import imgDefault from "../assets/plant-default.svg";

function ImgDefault(props) {
  return <img src={imgDefault} alt="" {...props} />;
}

export default ImgDefault;
